import { ErrorContainer, Stack } from 'components';
import { useFormikContext } from 'formik';
import { TextAreaInputField } from 'components/inputField/textAreaInpuField';

import { FormValues } from '../../clientForm';
import SectionTitle from '../sectionTitle/sectionTitle';

const SupportPeople = () => {
  const formik = useFormikContext<FormValues>();

  return (
    <Stack gap="24px" data-test-id="profile-referral">
      <SectionTitle>Support People</SectionTitle>
      <Stack height="100px">
        <TextAreaInputField
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          value={formik.values.supportPeople ?? ''}
          placeholder="Enter support people"
          name="supportPeople"
        />
        <ErrorContainer
          visible={formik.errors.supportPeople && formik.touched.supportPeople}
          name="supportPeople"
          errors={formik.errors}
        />
      </Stack>
    </Stack>
  );
};

export default SupportPeople;
